var render = function render(){
  var _vm$modal$data, _vm$modal$data2, _vm$modal$data3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "centered": "",
      "size": "lg",
      "title": "Filter Data",
      "ok-title": "Filter"
    },
    on: {
      "ok": _vm.fetchData
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "variant": "outline-secondary"
          },
          on: {
            "click": _vm.resetFilter
          }
        }, [_c('i', {
          staticClass: "fas fa-undo mr-2"
        }), _vm._v(" Reset Filter ")]), _c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v("Cancel")]), _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return ok();
            }
          }
        }, [_vm._v("Apply Filter")])];
      }
    }]),
    model: {
      value: _vm.showModalFilter,
      callback: function callback($$v) {
        _vm.showModalFilter = $$v;
      },
      expression: "showModalFilter"
    }
  }, [[_c('FilterMaintenanceFormNew', {
    model: {
      value: _vm.filters,
      callback: function callback($$v) {
        _vm.filters = $$v;
      },
      expression: "filters"
    }
  })]], 2), _c('ImportPmsProcessMultipleModal', {
    attrs: {
      "isOpen": _vm.showModalImport,
      "hideTrigger": true,
      "refetch": _vm.fetchData
    },
    on: {
      "update:isOpen": function updateIsOpen($event) {
        _vm.showModalImport = $event;
      },
      "update:is-open": function updateIsOpen($event) {
        _vm.showModalImport = $event;
      }
    }
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("PMS (Plan Maintenance System)")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('PlanMaintenanceSummary', {
          attrs: {
            "meta": _vm.summaryData
          }
        }), _c('div', {
          staticClass: "d-flex justify-content-between align-items-center mb-4"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-form-input', {
          staticStyle: {
            "width": "220px"
          },
          attrs: {
            "id": "fleet_name",
            "type": "text",
            "placeholder": "Search Job Name..."
          },
          on: {
            "input": _vm.debouncedFetchData
          },
          model: {
            value: _vm.filters.search,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "search", $$v);
            },
            expression: "filters.search"
          }
        }), _c('date-picker', {
          staticClass: "mx-2",
          staticStyle: {
            "width": "240px"
          },
          attrs: {
            "range": "",
            "format": "DD/MM/YYYY"
          },
          model: {
            value: _vm.filters.dateRange,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "dateRange", $$v);
            },
            expression: "filters.dateRange"
          }
        }), _c('b-button', {
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.showModalFilter = true;
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-sliders"
        }), _vm._v(" Filter Data ")]), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "primary",
            "disabled": _vm.maintenanceChecked.length === 0
          },
          on: {
            "click": _vm.handleMultipleProcess
          }
        }, [_vm._v(" Multiple Process ")])], 1), _c('div', {
          staticClass: "d-flex"
        }, [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.openOfflineReport
          }
        }, [_vm._v(" Activity Report Offline ")]), _c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.onFleetSelectedForImport
          }
        }, [_c('i', {
          staticClass: "ri-download-2-line mr-1"
        }), _vm._v(" Import ")]), _c('b-button', {
          attrs: {
            "variant": "primary",
            "disabled": _vm.isLoading
          },
          on: {
            "click": _vm.handleExport
          }
        }, [_c('i', {
          staticClass: "ri-upload-2-line mr-1"
        }), _vm._v(" Export ")])], 1)]), _c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table align-middle table-striped table-hover table-bordered"
        }, [_c('thead', {
          staticClass: "thead-light"
        }, [_c('tr', [_c('th', {
          staticClass: "aliign-middle text-center"
        }, [_c('b-form-checkbox', {
          on: {
            "change": function change($event) {
              return _vm.toggleSelectAll($event);
            }
          },
          model: {
            value: _vm.isCheckedAll,
            callback: function callback($$v) {
              _vm.isCheckedAll = $$v;
            },
            expression: "isCheckedAll"
          }
        })], 1), _c('th', [_vm._v("Fleet Name")]), _c('th', [_vm._v("Job Name")]), _c('th', [_vm._v("Equipment")]), _c('th', [_vm._v("Job Type")]), _c('th', [_vm._v("Interval")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Last")]), _c('th', [_vm._v("Due")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Current")]), _c('th', [_vm._v("Postpon")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Status")]), _c('th')])]), _c('tbody', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm.isLoading ? _c('tr', [_c('td', {
          staticClass: "text-center py-4",
          attrs: {
            "colspan": "12"
          }
        }, [_c('b-spinner', {
          attrs: {
            "label": "Loading..."
          }
        })], 1)]) : [!_vm.maintenanceData.length ? _c('tr', [_c('td', {
          staticClass: "text-center py-4 text-muted",
          attrs: {
            "colspan": "12"
          }
        }, [_vm._v(" No data available ")])]) : _vm._e(), _vm._l(_vm.maintenanceData, function (job, index) {
          var _job$job_library, _job$job_library2, _job$job_library3, _job$postpones, _job$postpones$, _job$postpones$2, _job$postpones$3;
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "align-middle text-center"
          }, [_c('b-form-checkbox', {
            attrs: {
              "value": job.id,
              "disabled": !_vm.statusMaintenable.includes(job.status)
            },
            model: {
              value: _vm.maintenanceChecked,
              callback: function callback($$v) {
                _vm.maintenanceChecked = $$v;
              },
              expression: "maintenanceChecked"
            }
          })], 1), _c('td', [_c('span', {
            staticClass: "badge badge-success px-2 py-1"
          }, [_vm._v(" " + _vm._s(job.vehicle_name) + " ")])]), _c('td', {
            staticClass: "p-0"
          }, [_c('div', {
            staticClass: "font-weight-bold p-2 px-3 text-nowrap"
          }, [_vm._v(" " + _vm._s(job === null || job === void 0 ? void 0 : (_job$job_library = job.job_library) === null || _job$job_library === void 0 ? void 0 : _job$job_library.name) + " ")]), job.triggers == 'COUNTER' ? _c('div', {
            staticClass: "border-top p-2 px-3"
          }, [_c('small', {
            staticClass: "text-muted text-nowrap"
          }, [_vm._v(" " + _vm._s(job === null || job === void 0 ? void 0 : job.power_type_name) + " | " + _vm._s(job === null || job === void 0 ? void 0 : job.power_series_name) + " " + _vm._s(job === null || job === void 0 ? void 0 : job.power_series_model) + " ")])]) : _vm._e()]), _c('td', {
            staticClass: "p-0"
          }, [_c('div', {
            staticClass: "font-weight-bold p-2 px-3 text-primary text-nowrap"
          }, [_vm._v(" " + _vm._s(job.equipment_name || '-') + " ")]), _c('div', {
            staticClass: "border-top p-2 px-3"
          }, [_c('small', {
            staticClass: "text-muted text-nowrap"
          }, [_vm._v(" " + _vm._s(job.component_name || '-') + " ")])])]), _c('td', {
            staticClass: "p-0"
          }, [_c('div', {
            staticClass: "font-weight-bold p-2 text-nowrap px-3"
          }, [_vm._v(" " + _vm._s(job === null || job === void 0 ? void 0 : job.job_type_name) + " ")]), _c('div', {
            staticClass: "border-top p-2 px-3"
          }, [_c('small', {
            staticClass: "text-muted"
          }, [_vm._v(" " + _vm._s(job === null || job === void 0 ? void 0 : job.job_class_name) + " ")])])]), _c('td', {
            staticClass: "p-0"
          }, [_c('div', {
            staticClass: "font-weight-bold p-2 px-3 text-nowrap"
          }, [job.triggers == 'CALENDAR' ? _c('div', [_vm._v(" " + _vm._s((_job$job_library2 = job.job_library) === null || _job$job_library2 === void 0 ? void 0 : _job$job_library2.calendar_interval) + " " + _vm._s((_job$job_library3 = job.job_library) === null || _job$job_library3 === void 0 ? void 0 : _job$job_library3.calendar_type) + " ")]) : _c('div', [_vm._v(" " + _vm._s(_vm.formatNumber(job.trigger_interval)) + " Hr ")])]), _c('div', {
            staticClass: "border-top p-2 px-3"
          }, [_c('small', {
            staticClass: "text-muted"
          }, [_vm._v(" " + _vm._s(job.triggers || '-') + " ")])])]), _c('td', {
            staticClass: "p-0 text-center"
          }, [_c('div', {
            staticClass: "p-2 px-3"
          }, [_vm._v(" " + _vm._s(job.last_maintenance_date ? _vm.formatDate(job.last_maintenance_date) : '-') + " ")]), job.triggers == 'COUNTER' ? _c('div', {
            staticClass: "p-2 px-3 border-top font-weight-bold"
          }, [_vm._v(" " + _vm._s(_vm.formatNumber(job.last_maintenance_hours) || '0') + " Hr ")]) : _vm._e()]), job.triggers == 'CALENDAR' ? _c('td', [_vm._v(" " + _vm._s(_vm.formatDate(job.possible_maintenance_date)) + " ")]) : _c('td', [_vm._v(" " + _vm._s(_vm.formatNumber(job.possible_maintenance_hours) || '0') + " Hr ")]), _c('td', {
            staticClass: "text-center"
          }, [job.triggers == 'COUNTER' ? [_vm._v(" " + _vm._s(_vm.formatNumber(job.total_running_hours) || '0') + " Hr ")] : [_vm._v("-")]], 2), _c('td', [job !== null && job !== void 0 && (_job$postpones = job.postpones) !== null && _job$postpones !== void 0 && _job$postpones.length ? _c('div', {
            staticClass: "text-primary cursor-pointer",
            staticStyle: {
              "text-decoration-line": "underline"
            },
            on: {
              "click": function click($event) {
                return _vm.showPostponeModal(job);
              }
            }
          }, [job.triggers == 'CALENDAR' ? [_vm._v(" " + _vm._s((_job$postpones$ = job.postpones[0]) !== null && _job$postpones$ !== void 0 && _job$postpones$.extra_date ? _vm.moment((_job$postpones$2 = job.postpones[0]) === null || _job$postpones$2 === void 0 ? void 0 : _job$postpones$2.extra_date).format('DD/MM/YYYY') : '-') + " ")] : [_vm._v(" " + _vm._s(_vm.formatNumber((_job$postpones$3 = job.postpones[0]) === null || _job$postpones$3 === void 0 ? void 0 : _job$postpones$3.extra_hours)) + " Hours ")]], 2) : _c('div', [_vm._v("-")])]), _c('td', {
            staticClass: "text-center"
          }, [_c('span', {
            staticClass: "badge",
            class: _vm.getStatusBadgeClass(job.status)
          }, [_vm._v(" " + _vm._s(job.status == 'MAINTENANCE' ? 'PROGRESS' : job.status || '-') + " ")])]), _c('td', {
            staticClass: "text-center"
          }, [_c('b-button', {
            staticClass: "p-1",
            attrs: {
              "id": "action-popover-".concat(index),
              "size": "sm",
              "variant": "link"
            }
          }, [_c('i', {
            staticClass: "fas fa-ellipsis-v text-dark"
          })]), _c('b-popover', {
            attrs: {
              "target": "action-popover-".concat(index),
              "placement": "bottom",
              "triggers": "focus"
            }
          }, [_c('div', {
            staticClass: "list-group list-group-flush"
          }, _vm._l(_vm.getActionMenuByJob(job), function (item, i) {
            return _c('button', {
              key: "act-".concat(i, "-").concat(item.key),
              staticClass: "list-group-item list-group-item-action",
              class: {
                'text-danger': item.variant === 'danger'
              },
              attrs: {
                "type": "button"
              },
              on: {
                "click": function click($event) {
                  return _vm.handleAction(item.key, job, index);
                }
              }
            }, [_vm._v(" " + _vm._s(item.label) + " ")]);
          }), 0)])], 1)]);
        })]], 2)])]), _c('div', {
          staticClass: "mt-4 pt-3 d-flex align-items-center w-100 justify-content-between"
        }, [_c('div', [_c('span', {
          staticClass: "mb-0"
        }, [_vm._v(" Total Rows : "), _c('strong', [_vm._v(_vm._s(_vm.filters.total))])])]), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.filters.total,
            "per-page": _vm.filters.limit,
            "disabled": _vm.isLoading,
            "first-number": "",
            "align": "center"
          },
          on: {
            "input": _vm.fetchData
          },
          model: {
            value: _vm.filters.page,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "page", $$v);
            },
            expression: "filters.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions,
            "disabled": _vm.isLoading
          },
          on: {
            "input": function input() {
              return _vm.fetchData();
            }
          },
          model: {
            value: _vm.filters.limit,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "limit", $$v);
            },
            expression: "filters.limit"
          }
        })], 1)])];
      },
      proxy: true
    }])
  }), _c('CustomSidebar', {
    attrs: {
      "title": _vm.sidebar.title,
      "size": _vm.sidebar.size
    },
    model: {
      value: _vm.sidebar.show,
      callback: function callback($$v) {
        _vm.$set(_vm.sidebar, "show", $$v);
      },
      expression: "sidebar.show"
    }
  }, [_vm.sidebar.title == 'Process Maintenance' || _vm.sidebar.title == 'Edit Maintenance' ? [_vm.sidebar.show ? _c('MaintenanceProcessInfo', {
    attrs: {
      "selectedData": _vm.sidebar.data,
      "isEditMode": _vm.sidebar.title == 'Edit Maintenance'
    },
    on: {
      "close": _vm.closeSidebar,
      "refetch": _vm.fetchData
    }
  }) : _vm._e()] : _vm._e(), _vm.sidebar.title == 'Multiple Process Maintenance' ? [_c('FormMaintenanceProcess', {
    attrs: {
      "multipleSelected": _vm.sidebar.data
    },
    on: {
      "close": _vm.closeSidebar,
      "refetch": _vm.fetchData
    }
  })] : _vm._e(), _vm.sidebar.title == 'Detail Maintenance' || _vm.sidebar.title == 'Approve Maintenance' ? [_c('MaintenanceDetail', {
    attrs: {
      "selectedData": _vm.sidebar.data,
      "isApprovalMode": _vm.sidebar.title == 'Approve Maintenance'
    },
    on: {
      "approve": function approve($event) {
        return _vm.approvalJob(_vm.sidebar.data, 'approve');
      },
      "reject": function reject($event) {
        return _vm.approvalJob(_vm.sidebar.data, 'reject');
      },
      "cancel": _vm.closeSidebar
    }
  })] : _vm._e()], 2), _c('b-modal', {
    attrs: {
      "title": _vm.modal.title,
      "size": _vm.modal.size,
      "hide-footer": ""
    },
    model: {
      value: _vm.modal.show,
      callback: function callback($$v) {
        _vm.$set(_vm.modal, "show", $$v);
      },
      expression: "modal.show"
    }
  }, [_vm.modal.show ? [_vm.modal.title === 'Postponed' ? [_c('FormMaintenancePostpone', {
    attrs: {
      "methodType": (_vm$modal$data = _vm.modal.data) === null || _vm$modal$data === void 0 ? void 0 : _vm$modal$data.triggers,
      "selectedData": _vm.modal.data
    },
    on: {
      "close": _vm.cancelPostpon,
      "refetch": _vm.fetchData
    }
  })] : _vm._e(), _vm.modal.title === 'Postpon Info' ? [_c('PostponeLogs', {
    attrs: {
      "logs": (_vm$modal$data2 = _vm.modal.data) === null || _vm$modal$data2 === void 0 ? void 0 : _vm$modal$data2.postpones,
      "method": ((_vm$modal$data3 = _vm.modal.data) === null || _vm$modal$data3 === void 0 ? void 0 : _vm$modal$data3.triggers) || 'CALENDAR'
    }
  })] : _vm._e()] : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }